import { Input } from "antd";

import { BtnSubmit } from "../../../../../../components";

import classStyles from "../../index.module.css";

const RemarkTextArea = ({
  value,
  setValue,
  handleOkButton,
  setShowTextArea,
}) => {

  const val = value !== null ? value : ""

  return (
    <div className={classStyles["text-area"]}>
      <Input.TextArea
        value={val}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Type your remarks here..."
        autoSize={{
          minRows: 7,
          maxRows: 10,
        }}
        style={{ marginTop: "15px" }}
      />
      <div className={classStyles["buttons"]}>
        <BtnSubmit
          display="inline-block"
          text="Save"
          bgColor="#0E2483"
          color="var(--creamColor)"
          padding="15px 30px"
          onClick={handleOkButton}
        />
        <BtnSubmit
          display="inline-block"
          text="Cancel"
          bgColor="transparent"
          color="var(--bs-gray-600)"
          padding="9px 18px"
          onClick={() => {
            setShowTextArea(false);
          }}
        />
      </div>
    </div>
  );
};

export default RemarkTextArea;
